const initialState = {
  data: {
    country: 'United Kingdom'
  },
};
  
  export default initialState;
  